import { HumanFemaleBoyIcon } from './HumanFemaleBoyIcon';

/**
 * author: Henrique César Madeira
 * id 6FAD3199-1AC7-4265-84B0-E72818AD2447
 * name human-female-boy
 * version: 2.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/human-female-boy.svg
 * tags
 * - People / Family 
 */
export const MumIcon = HumanFemaleBoyIcon;
export default MumIcon